import { create } from 'zustand';

type VenueInquiryModalsState = {
    stagedVenue?: Bizly.Venue;
    stagedAction?: () => void;
    selectedVenueInquiry?: Bizly.Venue;
    selectedVenueInquiryAction?: () => void;
    openConfirmationDialog: boolean;
    showVenueGuidanceModal: boolean;
    showRightDrawer: boolean;
};

const initialState: VenueInquiryModalsState = {
    stagedVenue: undefined,
    stagedAction: undefined,
    selectedVenueInquiry: undefined,
    selectedVenueInquiryAction: undefined,
    openConfirmationDialog: false,
    showVenueGuidanceModal: false,
    showRightDrawer: false,
};

export const useVenueInquiryModals = create<VenueInquiryModalsState>(() => initialState);

const { setState } = useVenueInquiryModals;

export const venueInquiryModalsActions = {
    setStagedVenue: (venue?: Bizly.Venue, action?: () => void) =>
        setState({ stagedVenue: venue, stagedAction: action }),
    setSelectedVenueInquiry: (venue?: Bizly.Venue, action?: () => void) =>
        setState({ selectedVenueInquiry: venue, selectedVenueInquiryAction: action }),
    setOpenConfirmationDialog: (open: boolean) => setState({ openConfirmationDialog: open }),
    setShowVenueGuidanceModal: (show: boolean) => setState({ showVenueGuidanceModal: show }),
    setShowRightDrawer: (show: boolean) => setState({ showRightDrawer: show }),
    clearAllModals: () =>
        setState({
            stagedVenue: undefined,
            stagedAction: undefined,
            selectedVenueInquiry: undefined,
            selectedVenueInquiryAction: undefined,
            openConfirmationDialog: false,
            showVenueGuidanceModal: false,
            showRightDrawer: false,
        }),
};
